import { render, staticRenderFns } from "./saveStudentOffer.vue?vue&type=template&id=92c6c6c6&"
import script from "./saveStudentOffer.vue?vue&type=script&lang=js&"
export * from "./saveStudentOffer.vue?vue&type=script&lang=js&"
import style0 from "./saveStudentOffer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports